import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from 'src/app/app.contant';
import { INegotiationCreateRequest, IRFQTemplateDetail } from '../../pr-buyer/models';
import { IAPIResponse } from '../../shared/models';
import { EncryptionService } from '../../dashboard/services/encryption.service';

@Injectable({
  providedIn: 'root'
})
export class SupplierService {

  constructor(private http: HttpClient,private _encryptionService: EncryptionService) { }

  public getRFQQuotations(): Observable<IAPIResponse<IRFQTemplateDetail[]>> {
    return this.http.get<IAPIResponse<IRFQTemplateDetail[]>>(`${API_URL.SUPPLIER.RFQ.FETCH_QUOTATIONS}`);
  }

  public fetchRFQDetail(id : string = "") : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.RFQ.FETCH_RFQ_DETAILS}`+id);
  }

  public fetchVendorRFQDetail(id : string = "") : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.BUYER.RFQ.FETCH_VENDOR_RFQ_DETAILS}`+id);
  }

  public saveRFQQuotations(body : any) : Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.SUPPLIER.RFQ.UPDATE_QUOTATION}`, body);
  }

  public saveUnregisteredRFQQuotations(body : any) : Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.SUPPLIER.RFQ.UNREGISTERED_QUOTATION}`, body);
  }

  public fetchPOConfirmationData(status:any) : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.SUPPLIER.PO_CONFIRMATION.FETCH_PO_CONFIRMATION}`+status);
  }

  public getPOConfirmationData(poNumber:any) : Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.SUPPLIER.PO_CONFIRMATION.GET_PO_CONFIRMATION}`+poNumber);
  }

  public getScheduleItems(poNumber:any): Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.SUPPLIER.PO_CONFIRMATION.GET_SCHEDULE_ITEMS_DATA}`+poNumber);
  }

  public updateNegotiation(body: any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.NEGOTIATIONS.UPDATE}`, body);
  }

  public onBehalfOfSupplierUpdateNegotiationByBuyer(body: any) : Observable<any> {
    return this.http.post<any>(`${API_URL.BUYER.NEGOTIATIONS.UPDATEONBEHALFOF}`, body);
  }

  public uploadAttachmnet(rfq_id: any, uploadedFile: FormData): Observable<IAPIResponse<any>> {
    return this.http.post<IAPIResponse<any>>(`${API_URL.SUPPLIER.RFQ.UPLOAD_ATTACHMENT}${this._encryptionService.encryptPayload(rfq_id)}`, uploadedFile);
  }

  public getDeliveryAck(po_number:any): Observable<IAPIResponse<any>>{
    return this.http.get<IAPIResponse<any>>(`${API_URL.FETCH_DELIVER_ACK}`+po_number)
  }

  public supplierAcceptOrReject(payload:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.ACCEPT_DECLINE_SUPPLIER_QUOTATION}`,payload)
  }
  
  public getNegotiationForUnRegisteredVendor(templateId: any, supplier_id: any): Observable<IAPIResponse<any>> {
    return this.http.get<IAPIResponse<any>>(`${API_URL.GET_UNREGISTERED_VENDOR_NEGOTIATION + "id=" + templateId + "&supplierId=" + supplier_id}`)
  }

  public openOnboard(payload:any){
    return this.http.post<IAPIResponse<any>>(`${API_URL.POST_ONBOARD}`,payload)
  }
}
